import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import FolderCopyOutlinedIcon from '@mui/icons-material/FolderCopyOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import PersonSearchOutlinedIcon from '@mui/icons-material/PersonSearchOutlined';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import SourceOutlinedIcon from '@mui/icons-material/SourceOutlined';
import WorkHistoryOutlinedIcon from '@mui/icons-material/WorkHistoryOutlined';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import { Grid } from '@mui/material';

import AccessControl from '../../components/AccessControl/AccessControl';
import { SettingsHeader } from '../../components/SettingsHeader';
import SettingsIndex from '../../components/SettingsIndex';
import { WsBreadCrumbs } from '../../components/WsBreadCrumbs';
import { useWorkspaceContext } from '../../context';
import CircleUserLock from '../../images/content/CircleUserLock.svg';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../teams/helper/defaultValues';

const AccessControlListing = () => {
  const allOptions = [
    {
      label: 'ATS Access',
      icon: <LockOpenOutlinedIcon />,
      url: '/ats-access-control/',
    },
    {
      label: 'Users Management',
      url: '/users-access-control/',
      icon: <ManageAccountsOutlinedIcon />,
    },
    {
      label: 'Teams Management',
      url: '/teams-access-control/',
      icon: <GroupsOutlinedIcon />,
    },
    { label: 'Jobs Access', url: '/jobs-access-control', icon: <WorkOutlineIcon /> },
    {
      label: 'Candidate Access',
      url: '/candidate-access-control',
      icon: <PersonAddAltOutlinedIcon />,
    },
    {
      label: 'Attributes Visibility',
      url: '/attributes-visibility/',
      icon: <ListAltOutlinedIcon />,
    },
    {
      label: 'Native Search',
      url: '/native-search-access-control',
      icon: <PersonSearchOutlinedIcon />,
    },
    {
      label: 'Premium Job Boards',
      url: '/premium-job-access-control',
      icon: <WorkHistoryOutlinedIcon />,
    },
    {
      label: 'VMS Configuration',
      url: '/vms-access-control/',
      icon: <ConfirmationNumberOutlinedIcon />,
    },
    { label: 'SMS Configuration', url: '/sms-access-control/', icon: <SmsOutlinedIcon /> },
    {
      label: 'Composable Analytics Data Access',
      url: '/analytics-data-access-control/',
      icon: <FolderCopyOutlinedIcon />,
    },
    {
      label: 'Lead Access Control',
      url: '/lead-access-control',
      icon: <CategoryOutlinedIcon />,
    },
    {
      label: 'Client Listing Access Control',
      url: '/client-listing-access-control',
      icon: <CategoryOutlinedIcon />,
    },
    {
      label: 'Organisation Entity Access Control',
      url: '/entity-access-control',
      icon: <SourceOutlinedIcon />,
    },
  ];
  const northwind = [
    ...allOptions,
    { label: 'Custom Setup', url: '/ats-custom-control/', icon: <SourceOutlinedIcon /> },
  ];

  const workspace = useWorkspaceContext();
  return (
    <Grid container columnSpacing={2} rowSpacing={3}>
      <Grid item xs={12}>
        <WsBreadCrumbs
          breadCrumbsList={getSettingBreadCrumbList(
            ISettingBreadCrumbTypes.ACCOUNT,
            Pages['ACCESS_CONTROL_SETTINGS']
          )}
        />
        <SettingsHeader title="Access Control Settings" />
      </Grid>
      <Grid item xs={2.5}>
        {workspace.id == '415bf50c-51ce-4340-9008-f3c388f1af65' ? (
          <SettingsIndex options={northwind} />
        ) : (
          <SettingsIndex options={allOptions} />
        )}
      </Grid>
      <Grid item xs={8.5}>
        <AccessControl
          errorText="Specify privileges to the Role of the user to determine and grant access to view or manage data across different feature resources on the platform"
          icon={<img src={CircleUserLock} alt="No Data Available" />}
          hideNavigation={true}
        />
      </Grid>
    </Grid>
  );
};
export default AccessControlListing;
